import { Layout } from 'antd'
import * as React from 'react'

const { Content } = Layout

export const SiteContent: React.FC = (props) => {
	const { children } = props

	return <Content>{children}</Content>
}
